import { TabContainer } from "../ServicesTab/servicestab.styled";
import search from "../../assets/searchIcon.svg";
import { Header, Numbers, TableSection } from "./Tabs.styled";
import { Table } from "../MoveOutTerminationTabs/MoveOut.styled";
// import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
// import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
// import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { FC, ReactElement, useEffect, useState } from "react";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import { toJS } from "mobx";

interface Obj {
  [key: string]: any;
}

interface Props {
  GetServiceAccounts: () => {};
  serviceAccounts: Obj[];
  addAccount: (a: {}) => void;
  removeAccount: (a: string) => void;
  Next: React.MouseEventHandler<HTMLButtonElement>;
  setinputValue: any;
  serviceLoader: any;
}

const ServiceAccounts: FC<Props> = ({
  GetServiceAccounts,
  setinputValue,
  serviceAccounts,
  addAccount,
  removeAccount,
  Next,
  serviceLoader
}: Props): ReactElement => {
  // State variables to keep track of selected accounts
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState<string[]>([]);
  const [serviceAccountsdata, setServiceAccounts] = useState<any>([]);
  const handleAccountToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const index = parseInt(event.target.value);
    setinputValue(index + 1);
    if (event.target.checked) {
      addAccount(serviceAccountsdata[index]);
      // Add the selected account to the list
      setSelectedAccounts((prevSelectedAccounts) => [
        ...prevSelectedAccounts,
        serviceAccountsdata[index].accountId,
      ]);
    } else {
      removeAccount(serviceAccountsdata[index].accountId);
      // Remove the selected account from the list
      setSelectedAccounts((prevSelectedAccounts) =>
        prevSelectedAccounts.filter(
          (accountId) => accountId !== serviceAccountsdata[index].accountId
        )
      );
    }
  };

  const handleSelectAllToggle = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isChecked = event.target.checked;
    setSelectAllChecked(isChecked);

    // Update the selectedAccounts state based on isChecked
    if (isChecked) {
      setSelectedAccounts(serviceAccountsdata.map((account: any) => account.accountId));
    } else {
      setSelectedAccounts([]);
    }

    // Call handleAccountToggle for each account when selecting all from header checkbox
    serviceAccountsdata?.forEach((account: any, index: any) => {
      if (isChecked) {
        addAccount(account);
      } else {
        removeAccount(account.accountId);
      }
    });
  };
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const toz = event.target.value;
    const initData = serviceAccountsdata;
    const filteredCases =
      toz != null && toz != ""
        ? initData.filter((payment: any) => {
          const searchString = toz.toLowerCase(); // Convert the filter to lowercase for case-insensitive search
          return Object.values(payment).some((value) => {
            if (value && typeof value === "string") {
              return value.toLowerCase().includes(searchString);
            }
            return false;
          });
        })
        : initData;
    setServiceAccounts([...filteredCases]);
  };
  useEffect(() => {
    // GetServiceAccounts();
    setServiceAccounts(serviceAccounts)
  }, [serviceAccounts]);
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <TabContainer style={{ width: "100%", marginTop: "30px" }}>
      <Header style={{ flexDirection: General?.isLargeScreen ? 'row' : 'column', width: General?.isLargeScreen ? '' : "100%", marginTop: General?.isLargeScreen ? '' : '3rem' }}>
        <div style={{ width: General?.isLargeScreen ? "" : "100%" }} >
          <span
            style={{
              fontWeight: "700",
              fontSize: `${1.5 * General.accessibility.fontSize}rem`,
              lineHeight: "32px",
              color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              marginTop: General?.isLargeScreen ? '' : '1rem'
            }}
          >
            {General?.codeLabels["cm_pdc_paymentserviceaccount"]?.label !==
              undefined
              ? General?.codeLabels["cm_pdc_paymentserviceaccount"]?.label
              : "Service Accounts"}
          </span>
          <span
            style={{
              fontWeight: "400",
              fontSize: `${0.875 * General.accessibility.fontSize}rem`,
              lineHeight: "14px",
              color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
              marginTop: General?.isLargeScreen ? '' : '1rem'
            }}
          >
            {General?.codeLabels["cm_plan_detail_create"]?.label ? General?.codeLabels["cm_plan_detail_create"]?.label : 'Add Service from the list below to create plan request'}
          </span>
        </div>
        <div style={{ width: General?.isLargeScreen ? "" : "100%", marginTop: General?.isLargeScreen ? '' : '1rem' }}>
          <input
            onChange={handleSearchChange}
            type="text"
            placeholder={General?.codeLabels["cm_search"]?.label ? General?.codeLabels["cm_search"]?.label : 'Search'}
            style={{
              width: General?.isLargeScreen ? "274px" : "100%",
              height: "38px",
              fontSize: `${General.accessibility.fontSize}rem`,
              paddingLeft: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '40px' : '10px',
              paddingRight: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '10px' : '40px',
              position: "relative",
              color: contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss,
              backgroundColor: contrast?.contrastColor ? contrast?.contrastColor : "",
            }}
          />
          <span style={{
            paddingRight: "10px",
            width: "2vw",
            height: "3vh",
            display: "flex",
            alignItems: "center",
            marginLeft: '20px',
            position:"absolute"
          }}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6273 7.14735C13.6273 3.57556 10.7187 0.666992 7.14694 0.666992C3.57515 0.666992 0.666584 3.57556 0.666584 7.14735C0.666584 10.7191 3.57515 13.6277 7.14694 13.6277C8.69868 13.6277 10.1213 13.0835 11.2377 12.1696L16.4017 17.3337L17.3333 16.4021L12.1692 11.2381C13.083 10.1217 13.6273 8.69909 13.6273 7.14735ZM1.96266 7.14735C1.96266 4.27675 4.27635 1.96306 7.14694 1.96306C10.0175 1.96306 12.3312 4.27675 12.3312 7.14735C12.3312 10.0179 10.0175 12.3316 7.14694 12.3316C4.27635 12.3316 1.96266 10.0179 1.96266 7.14735Z" fill={contrast?.contrastBackground ? contrast?.contrastBackground : ColorAss} />
            </svg>

          </span>
         
        </div>
      </Header>
      {serviceLoader ? <Spinner /> : <>
        <div style={{ width: General?.isLargeScreen ? "" : "100%", overflow: "auto" }}>
          <Table  style={{ marginTop: General?.isLargeScreen ? '' : '2rem', overflow: 'auto' }} lastChild={true} beforeLastChild={true}>
            <thead>
              <tr
                style={{
                  gap: "1rem",
                  background: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    :"",
                }}
              >
                <th
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    // display: 'flex',
                    // justifyContent: 'Start'
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectAllChecked}
                    onChange={handleSelectAllToggle}
                    style={{
                      marginInlineEnd: "15px",
                    }}
                  />
                  <span
                    style={{
                      color: contrast?.contrastColor ? contrast?.contrastColor :ColorAss,
                    }}
                  >
                    {General?.codeLabels["cm_accountid"]?.label !== undefined
                      ? General?.codeLabels["cm_accountid"]?.label
                      : "Account Number"}
                  </span>
                </th>
                <th
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor ? contrast?.contrastColor : "",
                  }}
                >
                   <span
                    style={{
                      color: contrast?.contrastColor ? contrast?.contrastColor :ColorAss,
                    }}
                  >
                  {General?.codeLabels["cm_premiseid"]?.label !== undefined
                    ? General?.codeLabels["cm_premiseid"]?.label
                    : "Sewerage Number"}
                    </span>
                </th>
                <th
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor ? contrast?.contrastColor : "",
                  }}
                >
                  <span
                    style={{
                      color: contrast?.contrastColor ? contrast?.contrastColor :ColorAss,
                    }}
                  >
                  {General?.codeLabels["cm_pdc_premisedetails"]?.label !== undefined
                    ? General?.codeLabels["cm_pdc_premisedetails"]?.label
                    : "Premise Details"}
                    </span>
                </th>
                <th
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor ? contrast?.contrastColor : "",
                  }}
                >
                  <span
                    style={{
                      color: contrast?.contrastColor ? contrast?.contrastColor :ColorAss,
                    }}
                  >
                  {General?.codeLabels["cm_dpremiseusage"]?.label !== undefined
                    ? General?.codeLabels["cm_dpremiseusage"]?.label
                    : "Premise Usage"}
                    </span>
                </th>
                <th
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor ? contrast?.contrastColor : "",
                  }}
                >
                  <span
                    style={{
                      color: contrast?.contrastColor ? contrast?.contrastColor :ColorAss,
                    }}
                  >
                  {General?.codeLabels["cm_amt_due"]?.label !== undefined
                    ? General?.codeLabels["cm_amt_due"]?.label
                    : "Amount Due"}{General?.codeLabels['cm_mob_aed']?.label ? General?.codeLabels['cm_mob_aed']?.label : "AED"}
                    </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {serviceAccountsdata?.length > 0 ? (
                serviceAccountsdata?.map((row: Obj, index: number) => {
                  return (
                    <tr
                      style={{
                        background: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : "",
                      }}
                    >
                      <td
                        style={{
                          fontSize: `${General.accessibility.fontSize}rem`,
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,
                        }}
                      >
                        <input
                          type="checkbox"
                          value={index}
                          onChange={handleAccountToggle}
                          style={{
                            marginInlineEnd: "15px",
                          }}
                        />
                        {row.accountId}
                      </td>
                      <td
                        style={{
                          fontSize: `${General.accessibility.fontSize}rem`,
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,
                        }}
                      >
                        {row.premiseId}
                      </td>
                      <td
                        style={{
                          fontSize: `${General.accessibility.fontSize}rem`,
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,
                        }}
                      >
                        {row.premiseAddress}
                      </td>
                      <td
                        style={{
                          fontSize: `${General.accessibility.fontSize}rem`,
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,
                        }}
                      >
                        {row.propertyUsage}
                      </td>
                      <td
                        style={{
                          fontSize: `${General.accessibility.fontSize}rem`,
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : ColorAss,
                        }}
                      >
                        {row.currentBalance /*row.serviceFee+row.vatCharges*/}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <p
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor ? contrast?.contrastColor : "",
                  }}
                >
                  {General?.codeLabels["cn_no_data"]?.label ? General?.codeLabels["cn_no_data"]?.label : 'No Data No Data Available'}
                </p>
              )}
            </tbody>
          </Table>
        </div>

        <hr style={{ width: "100%", marginBottom: "20px" }} />
        <ButtonSecondary
          style={{
            width: General?.isLargeScreen ? "20%" : "100%",
            fontSize: `${General.accessibility.fontSize}rem`,
            color: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "#fff",
            background: contrast?.contrastColor
              ? contrast?.contrastColor
              : ColorAss,
              border:"none",
          }}
          onClick={Next}
          // disabled={ !inputValue}
        >
          {General?.codeLabels["cm_next"]?.label !== undefined
            ? General?.codeLabels["cm_next"]?.label
            : "NEXT"}
        </ButtonSecondary>
      </>}
    </TabContainer>
  );
};

export default observer(ServiceAccounts);
